"use strict";
exports.__esModule = true;
exports.SvgStarFill = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgStarFill = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "#E6A907", fillRule: "nonzero", d: "M7.007 1c.285.013.499.16.62.418l1.47 3.125 3.311.507a.675.675 0 01.556.488c.083.263.02.52-.17.715L10.39 8.705l.572 3.48c.08.528-.44.967-.931.76l-.139-.066L7 11.282l-2.873 1.584c-.224.123-.374.166-.582.109a.702.702 0 01-.508-.78l.568-3.49-2.412-2.461-.032-.038c-.339-.422-.116-1.065.416-1.154l.358-.057 2.962-.454 1.48-3.137.046-.083a.662.662 0 01.453-.31L6.99 1h.017z" }),
        react_1["default"].createElement("path", { d: "M0 0h14v14H0z" })))); };
//# sourceMappingURL=StarFill.js.map